(() => {
  if (window.__auroraQuickViewUniversalV2) return;
  window.__auroraQuickViewUniversalV2 = true;

  const SELECTOR = '.aurora-quick-view';

  function getModalFromButton(button) {
    const opener = button?.closest('modal-opener');
    const selector = opener?.getAttribute('data-modal');
    return selector ? document.querySelector(selector) : null;
  }

  function getProductData(modal) {
    const node = modal?.querySelector('.aurora-qv-product-json');
    if (!node) return null;

    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function getCurrentVariantId(modal) {
    const formInput =
      modal?.querySelector('product-form input[name="id"]') ||
      modal?.querySelector('form[data-type="add-to-cart-form"] input[name="id"]') ||
      modal?.querySelector('.product-form input[name="id"]');

    const value = Number(formInput?.value);
    return Number.isFinite(value) && value > 0 ? value : null;
  }

  function getCurrentVariant(modal) {
    const product = getProductData(modal);
    if (!product?.variants?.length) return null;

    const currentId = getCurrentVariantId(modal);
    if (currentId) {
      const byId = product.variants.find((variant) => Number(variant.id) === currentId);
      if (byId) return byId;
    }

    const triggerId = Number(modal?.dataset.auroraInitialVariantId);
    if (triggerId) {
      const byTrigger = product.variants.find((variant) => Number(variant.id) === triggerId);
      if (byTrigger) return byTrigger;
    }

    return product.variants[0] || null;
  }

  function getVariantImageSrc(variant) {
    if (!variant) return null;

    const featured =
      variant.featured_media?.preview_image ||
      variant.featured_image ||
      null;

    if (typeof featured === 'string') return featured;

    return (
      featured?.src ||
      featured?.url ||
      variant.featured_image?.src ||
      variant.featured_image?.url ||
      null
    );
  }

  function updateMobileImage(modal, variant = null) {
    if (!modal) return;

    const mobileImage = modal.querySelector('.aurora-qv-mobile-head__image');
    if (!mobileImage) return;

    /*
      Cuando Dawn confirma una variante nueva, usamos directamente
      la imagen de ESA variante. Esto evita copiar por accidente la
      imagen anterior mientras la galería termina de actualizarse.
    */
    const variantSrc = getVariantImageSrc(variant);

    if (variantSrc) {
      mobileImage.src = variantSrc;
      mobileImage.removeAttribute('srcset');
      return;
    }

    /*
      En apertura inicial, la galería ya conoce la imagen activa.
      La copiamos conservando srcset cuando existe.
    */
    const activeImage = modal.querySelector('.product__media-item.is-active img');

    if (activeImage) {
      const src = activeImage.currentSrc || activeImage.src;
      if (src) mobileImage.src = src;

      const srcset = activeImage.getAttribute('srcset');
      if (srcset) {
        mobileImage.setAttribute('srcset', srcset);
      } else {
        mobileImage.removeAttribute('srcset');
      }

      return;
    }

    /* Fallback final: variante que figure actualmente en el formulario. */
    const currentVariant = getCurrentVariant(modal);
    const currentVariantSrc = getVariantImageSrc(currentVariant);

    if (currentVariantSrc) {
      mobileImage.src = currentVariantSrc;
      mobileImage.removeAttribute('srcset');
    }
  }

 function updateReviewCount(modal) {
  if (!modal) return;

  const sourceText =
    modal.querySelector(
      '.aurora-qv-review-count-source'
    )?.textContent || '';

  const datasetText =
    modal.dataset.auroraReviewCount || '';

  const judgeMeBadge =
    modal.querySelector('.jdgm-prev-badge');

  const judgeMeCount =
    judgeMeBadge?.getAttribute('data-number-of-reviews') ||
    judgeMeBadge?.dataset?.numberOfReviews ||
    '';

  const raw =
    `${sourceText} ${datasetText} ${judgeMeCount}`;

  const count =
    raw.match(/\d+/)?.[0];

  if (!count) return;

 const stars =
  modal.querySelector('.jdgm-prev-badge__stars') ||
  modal.querySelector('.rating-star') ||
  modal.querySelector('.rating');

const host =
  stars?.parentElement ||
  judgeMeBadge ||
  modal.querySelector('.rating-wrapper');

if (!host || !stars) return;

  /* Si ya existe un contador visible con número, no duplicarlo. */
  const nativeCount =
    host.querySelector('.rating-count') ||
    host.querySelector('.jdgm-prev-badge__text');

  if (
    nativeCount &&
    /\d+/.test(nativeCount.textContent || '') &&
    getComputedStyle(nativeCount).display !== 'none' &&
    getComputedStyle(nativeCount).visibility !== 'hidden'
  ) {
    return;
  }

  let countElement = host.querySelector('.aurora-qv-rating-count');

  if (!countElement) {
    countElement = document.createElement('span');
    countElement.className = 'aurora-qv-rating-count';
    stars.insertAdjacentElement('afterend', countElement);
  }

  const nextText = `(${count})`;
  if (countElement.textContent !== nextText) {
    countElement.textContent = nextText;
  }
}

  function productUrl(modal, variantId = null) {
    const baseUrl = modal?.dataset.auroraProductUrl;
    if (!baseUrl) return null;
    return variantId ? `${baseUrl}?variant=${variantId}` : baseUrl;
  }

  function updateProductLinks(modal, variant = null) {
    if (!modal) return;

    const variantId = variant?.id || getCurrentVariantId(modal);
    const url = productUrl(modal, variantId);
    if (!url) return;

    modal.querySelectorAll('[data-aurora-product-link]').forEach((link) => {
      link.href = url;
    });

    const titleLink =
  modal.querySelector('.product__title > a');

if (titleLink) {
  titleLink.href = url;
  titleLink.classList.add(
    'aurora-qv-title-link'
  );
}

    const infoContainer = modal.querySelector('.product__info-container');
    if (!infoContainer) return;

    let details =
  modal.querySelector(
    '.product__view-details'
  ) ||
  modal.querySelector(
    '.aurora-qv-desktop-details'
  );

if (!details) {
  details =
    document.createElement('a');

  const cartRow =
    infoContainer.querySelector(
      'div:has(> product-form.product-form)'
    );

  if (cartRow) {
    cartRow.insertAdjacentElement(
      'afterend',
      details
    );
  } else {
    infoContainer.appendChild(details);
  }
}

details.className =
  'aurora-qv-desktop-details';

details.href = url;

if (details.textContent.trim() !== 'VER DETALLES') {
  details.textContent = 'VER DETALLES';
}
  }

  function finishModal(modal, variant = null) {
    if (!modal) return;

    updateReviewCount(modal);
    updateProductLinks(modal, variant);
    updateMobileImage(modal, variant);
  }

  function observeModal(modal) {
    if (!modal || modal.dataset.auroraObserved === 'true') return;

    modal.dataset.auroraObserved = 'true';

    const content = modal.querySelector('.quick-add-modal__content-info');
    if (!content) return;

    const observer = new MutationObserver(() => {
      if (modal.querySelector('product-info')) {
        requestAnimationFrame(() => finishModal(modal));
      }
    });

    observer.observe(content, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('[data-aurora-quick-view]');
      if (!button) return;

      const modal = getModalFromButton(button);
      if (!modal || typeof modal.show !== 'function') return;
      const card = button.closest('.aurora-home-card');
      const cardCountText =
        card?.querySelector('.aurora-home-card__rating-count, .rating-count')?.textContent || '';
      const cardCount = cardCountText.match(/\d+/)?.[0];

      if (cardCount) {
        modal.dataset.auroraReviewCount = cardCount;
      }

      event.preventDefault();
      event.stopPropagation();

      modal.dataset.auroraInitialVariantId = button.dataset.variantId || '';
      observeModal(modal);

      modal.classList.remove('aurora-qv-just-opened');
      void modal.offsetWidth;
      modal.classList.add('aurora-qv-just-opened');

      modal.show(button);

      setTimeout(() => finishModal(modal), 80);
      setTimeout(() => finishModal(modal), 260);
    },
    true
  );

  document.addEventListener('product-info:loaded', (event) => {
    const modal = event.target.closest?.(SELECTOR);
    if (!modal) return;
    requestAnimationFrame(() => finishModal(modal));
  });

  /*
    Dawn publica este evento cuando ya resolvió la variante seleccionada.
    Es el punto más confiable para sincronizar la foto del encabezado móvil.
  */
  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined' &&
    PUB_SUB_EVENTS.variantChange
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
      const variant = data?.variant;
      if (!variant) return;

      document.querySelectorAll(`${SELECTOR}[open]`).forEach((modal) => {
        const productInfo = modal.querySelector('product-info');
        if (!productInfo) return;

        const sourceSection =
          productInfo.dataset.originalSection || productInfo.dataset.section || '';

        if (data?.sectionId && sourceSection && sourceSection !== data.sectionId) return;

        requestAnimationFrame(() => finishModal(modal, variant));
        setTimeout(() => finishModal(modal, variant), 120);
      });
    });
  }

  document.addEventListener('change', (event) => {
    const modal = event.target.closest?.(`${SELECTOR}[open]`);
    if (!modal) return;

    setTimeout(() => finishModal(modal), 60);
    setTimeout(() => finishModal(modal), 180);
  });

  document.addEventListener('click', (event) => {
    const modal = event.target.closest?.(`${SELECTOR}[open]`);
    if (!modal) return;

    if (
      event.target.closest(
        'variant-selects label, variant-selects input, variant-selects select, .product-form__input label'
      )
    ) {
      setTimeout(() => finishModal(modal), 100);
      setTimeout(() => finishModal(modal), 240);
      setTimeout(() => finishModal(modal), 450);
    }
  });
})();
